import React from 'react';
import { ToastContainer } from 'react-toastify';
import './ReactToastify.css';

function ReactToastify() {
  return (
    <ToastContainer
      position="bottom-right"
      autoClose={2000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  );
}

export default ReactToastify;
